import React from 'react';
import {
  List,
  Datagrid,
  TextField,
} from 'react-admin';

const CodigoRechazoList = (props) => (
  <List {...props} filter={{ deleted: false }}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="descripcion" />
    </Datagrid>
  </List>
);

export default CodigoRechazoList;
